import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './adminLogin.css';
import API_BASE_URL from '../../../config/api';

const AdminLogin = () => {
    const navigate = useNavigate();

    const [loginData, setLoginData] = useState({
        adminId: '',
        password: ''
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const {
            name,
            value
        } = e.target;

        setLoginData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!loginData.adminId.trim()) {
            alert('아이디를 입력해주세요.');
            return;
        }

        if (!loginData.password.trim()) {
            alert('비밀번호를 입력해주세요.');
            return;
        }

        try {
            setIsLoading(true);

            const response = await fetch(
                `${API_BASE_URL}/api/admin/login`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        adminId: loginData.adminId,
                        password: loginData.password
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.message ||
                    '로그인에 실패했습니다.'
                );
            }

            navigate('/admin/dashboard');
        } catch (error) {
            console.error(
                '관리자 로그인 오류:',
                error
            );

            alert(
                error.message ||
                '로그인 중 오류가 발생했습니다.'
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-login">
            <div className="admin-login-panel">
                <div className="admin-login-brand">
                    <span>
                        MTMEDIA
                    </span>

                    <h1>
                        ADMIN
                    </h1>

                    <p>
                        MTMEDIA 홈페이지
                        <br />
                        관리자 시스템
                    </p>
                </div>
            </div>

            <div className="admin-login-content">
                <form
                    className="admin-login-form"
                    onSubmit={handleSubmit}
                >
                    <div className="admin-login-heading">
                        <p>
                            ADMINISTRATOR
                        </p>

                        <h2>
                            관리자 로그인
                        </h2>

                        <span>
                            관리자 계정으로 로그인해주세요.
                        </span>
                    </div>

                    <div className="admin-login-field">
                        <label htmlFor="adminId">
                            아이디
                        </label>

                        <div className="admin-login-input">
                            <i className="mdi mdi-account-outline"></i>

                            <input
                                id="adminId"
                                name="adminId"
                                type="text"
                                value={loginData.adminId}
                                onChange={handleChange}
                                placeholder="아이디를 입력해주세요."
                                autoComplete="username"
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="admin-login-field">
                        <label htmlFor="password">
                            비밀번호
                        </label>

                        <div className="admin-login-input">
                            <i className="mdi mdi-lock-outline"></i>

                            <input
                                id="password"
                                name="password"
                                type="password"
                                value={loginData.password}
                                onChange={handleChange}
                                placeholder="비밀번호를 입력해주세요."
                                autoComplete="current-password"
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="admin-login-button"
                        disabled={isLoading}
                    >
                        {isLoading
                            ? '로그인 중...'
                            : '로그인'
                        }

                        {!isLoading && (
                            <i className="mdi mdi-arrow-right"></i>
                        )}
                    </button>

                    <div className="admin-login-help">
                        관리자 계정은 홈페이지 운영자만 사용할 수 있습니다.
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;